import React from 'react';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { QueryClient, QueryClientProvider } from 'react-query';

import 'moment/locale/sk';

import BSReboot from '@common/assets/styles/bs-reboot';
import StylesHilbi from '@common/assets/styles/hilbi';

import skCommon from '@common/locale/sk';
import skWidget from '@locale/sk';

import Layout from '@components/layout/layout';
import store from '@store/index';
import { COLOR_BLUE_007, COLOR_WHITE } from '@common/assets/styles/colors';

const GlobalStyle = createGlobalStyle`
    ${BSReboot}
    ${StylesHilbi}
    
      /* width */
    ::-webkit-scrollbar {
      width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${COLOR_WHITE};
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${COLOR_BLUE_007};
      border-radius: 4px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${COLOR_BLUE_007};
    }
`;

const currentLang = 'sk';
const locale = {
  sk: {
    ...skCommon,
    ...skWidget,
  },
};

const queryClient = new QueryClient();



const Widget: React.FC = () => (
    <>
      <GlobalStyle />
      <Provider store={store}>
        <IntlProvider locale={currentLang} messages={locale[currentLang]}>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={{ responsive:  window.screen.width <= 575.98 }}>
              <Layout />
            </ThemeProvider>
          </QueryClientProvider>
        </IntlProvider>
      </Provider>
    </>
  );


export default Widget;
